<template lang="pug">
#fonte(v-if='Object.values(fonte).length || {}')
    el-collapse.mx-2
        el-collapse-item
            p(slot='title') {{ $t('mensagens.diagnosticoSocioambiental.fonteDosDados') }}

            p.mb-2 {{ $t('mensagens.diagnosticoSocioambiental.dataDeCadastro') }}: {{ fonte.dataCadastro || '-' }}
            p.mb-2 {{ $t('mensagens.diagnosticoSocioambiental.nome') }}: {{ fonte.nome || '-' }}
            a(
                v-if='fonte.url',
                :href='fonte.url',
                type='success',
                target='_blank'
            ) {{ $t('mensagens.diagnosticoSocioambiental.siteFonte') }}
</template>

<script>
export default {
    name: 'Fonte',

    data() {
        return {};
    },

    props: {
        fonte: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss">
#fonte {
    margin-left: 13px;

    .el-icon-arrow-right {
        margin-top: -13px;
        margin-left: 5px;
    }

    .el-collapse-item__wrap {
        border: none;
    }

    .el-collapse-item__header {
        border-bottom: none;
    }

    p {
        line-height: 1;
    }
}
</style>
